module.exports = __webpack_public_path__ + "static/media/downloads@2x.e5d0c64e.mov";